import { where, QueryConstraint } from 'firebase/firestore';
import { getActiveOrgId, DEFAULT_ORG_ID } from '../config/tenant';

/**
 * Org scoping for direct Firestore reads. Backend API calls are already
 * scoped via the x-organization-id header; these helpers cover the
 * firebase/firestore SDK reads that bypass the API.
 *
 * Uses getActiveOrgId (not getOrgIdFromHostname) so the platform-admin console's
 * selected tenant flows through — on the admin.konklave.app host the hostname
 * resolves to the bogus label "admin", which matches no org.
 */

export function currentOrgId(): string {
  return getActiveOrgId();
}

export function orgWhere(): QueryConstraint {
  return where('organizationId', '==', currentOrgId());
}

/**
 * Tolerant check for single-doc reads: docs created before the
 * organizationId backfill are treated as kappa.
 */
export function belongsToCurrentOrg(data: Record<string, any> | undefined | null): boolean {
  if (!data) return false;
  return (data.organizationId || DEFAULT_ORG_ID) === currentOrgId();
}
